import { render, staticRenderFns } from "./AppEditorWindow.vue?vue&type=template&id=1998bc44&scoped=true&"
import script from "./AppEditorWindow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppEditorWindow.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AppEditorWindow.vue?vue&type=style&index=0&id=1998bc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998bc44",
  null
  
)

export default component.exports